<template>
  <div class="b-capsule-layer">
    <b-carousel
      ref="layerCarousel"
      :controls="showControls"
      :indicators="showIndicators"
      :interval="0"
      background="#fff"
      v-model="slide"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
      @mouseenter.native="toggleHover(true)"
      @mouseleave.native="toggleHover(false)"
    >
      <b-carousel-slide
        v-for="(product, index) in sortedBySequence(layer)"
        :key="product.id"
        :img-src="product.featured_image"
        :data-product-id="product.id"
        :data-product-index="index"
        v-on:click.native="clickProductSlide($event, product)"
      >
        <div class="brand">
          <span class="d-inline-block text-truncate" v-if="!detectMobile()">{{
            product.brand_name
          }}</span>
        </div>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
import CapsuleUtils from "@/utils/CapsuleUtils";
import MiscUtils from "@/utils/MiscUtils";

import { bus } from "@/main";

export default {
  props: {
    layer: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      hovering: false,
      slide: 0,
      sliding: null,
      dummyProducts: [
        {
          id: Math.floor(Math.random() * 20),
          featured_image: "https://via.placeholder.com/235x245/FFFFFF?text=+",
          brand_name: "",
          price_cents: 0,
          price_currency: "GBP",
          sequence: 1,
        },
      ],
    };
  },

  created() {
    this.detectMobile = MiscUtils.detectMobile;
    this.getGroupName = CapsuleUtils.getGroupName;
  },

  methods: {
    clickProductSlide(event, product) {
      this.openProductModal(product);
      // if (this.stitchMode) {
      //   // this.toggleSelection(product);
      //   this.toggleHover(false);
      // } else if (!this.detectMobile()) {
      //   this.openProductModal(product);
      // }
    },

    openProductModal(product) {
      bus.$emit(
        "openModal",
        product,
        this.getGroupName(this.layer.display_name)
      );
    },

    onSlideEnd(slide) {
      this.sliding = false;
    },

    onSlideStart(slide) {
      this.sliding = true;
    },

    sortedBySequence(layer) {
      if (layer.layer_products_count > 0) {
        return this.$lodash.sortBy(layer.products, "sequence");
      }
    },

    toggleHover(value) {
      this.hovering = value;
    },
  },

  computed: {
    showIndicators() {
      // return this.layer.products.count > 1;
      return false;
    },

    showControls() {
      // return this.hovering && this.hasControls;
      return false;
    },

    hasControls() {
      // return this.layer.products.count > 1;
      return false;
    },
  },
};
</script>

<style lang="scss">
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

.b-capsule-layer {
  cursor: pointer;
  border-top: 1px solid #ffffff;
  border-radius: 0.3em !important;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  &:hover {
    border-top: 1px solid #f2f2f2;
    box-shadow: 0px 5px 5px 0px rgba(169, 169, 169, 1);
  }

  .carousel,
  .carousel-inner {
    border-radius: 0.3em !important;
  }

  .carousel-indicators li {
    background-color: $primary-blue;
    margin-bottom: -15px !important;
    width: 5px;
    height: 5px;
    border-radius: 100%;
  }

  .carousel-item {
    padding: 0.5rem !important;

    @include for-tablet-portrait-up {
      padding: 1rem !important;
    }
  }
}

.embed-responsive-3by4 {
  &::before {
    padding-top: percentage(4 / 3);
  }
}

.carousel-caption {
  color: $primary-blue;
  position: relative;
  left: auto;
  right: auto;
  padding: 0;
  padding-top: 5px;
  padding-bottom: 5px;
  bottom: 0;
  font-weight: 100;
  color: #ccc;

  .brand {
    font-size: 14px;
    color: $grey3;
  }

  .price {
    font-size: 12px;
  }
}

.carousel-control-prev-icon {
  position: absolute;
  left: 0;
  padding: 11px;
  border-style: solid;
  border-color: $primary-blue;
  border-width: 6px 2px 6px 1px;
  background-color: $primary-blue;
  background-image: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxMjkgMTI5IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxMjkgMTI5IiB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4Ij4KICA8Zz4KICAgIDxwYXRoIGQ9Im04OC42LDEyMS4zYzAuOCwwLjggMS44LDEuMiAyLjksMS4yczIuMS0wLjQgMi45LTEuMmMxLjYtMS42IDEuNi00LjIgMC01LjhsLTUxLTUxIDUxLTUxYzEuNi0xLjYgMS42LTQuMiAwLTUuOHMtNC4yLTEuNi01LjgsMGwtNTQsNTMuOWMtMS42LDEuNi0xLjYsNC4yIDAsNS44bDU0LDUzLjl6IiBmaWxsPSIjRkZGRkZGIi8+CiAgPC9nPgo8L3N2Zz4K") !important;
}

.carousel-control-next-icon {
  position: absolute;
  right: 0;
  padding: 11px;
  border-style: solid;
  border-color: $primary-blue;
  border-width: 6px 1px 6px 2px;
  background-color: $primary-blue;
  background-color: $primary-blue;
  background-image: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxMjkgMTI5IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxMjkgMTI5IiB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4Ij4KICA8Zz4KICAgIDxwYXRoIGQ9Im00MC40LDEyMS4zYy0wLjgsMC44LTEuOCwxLjItMi45LDEuMnMtMi4xLTAuNC0yLjktMS4yYy0xLjYtMS42LTEuNi00LjIgMC01LjhsNTEtNTEtNTEtNTFjLTEuNi0xLjYtMS42LTQuMiAwLTUuOCAxLjYtMS42IDQuMi0xLjYgNS44LDBsNTMuOSw1My45YzEuNiwxLjYgMS42LDQuMiAwLDUuOGwtNTMuOSw1My45eiIgZmlsbD0iI0ZGRkZGRiIvPgogIDwvZz4KPC9zdmc+Cg==") !important;
}
</style>



// WEBPACK FOOTER //
// src/components/capsule/CapsuleLayerOld.vue